import { render, staticRenderFns } from "./ORTImpressionOptimizer.vue?vue&type=template&id=1cc4c2cd&scoped=true"
import script from "./ORTImpressionOptimizer.vue?vue&type=script&lang=js"
export * from "./ORTImpressionOptimizer.vue?vue&type=script&lang=js"
import style0 from "./ORTImpressionOptimizer.vue?vue&type=style&index=0&id=1cc4c2cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4c2cd",
  null
  
)

export default component.exports